// src/pages/stockout/stockOutComponent/StockOutSearch.js
import React from "react";
import {Grid, Typography, Button, Stack, Box} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {FormDatePicker, PickerSearch} from "../../../components";
import {useBranches} from "../hooks/useBranches";
import moment from "moment";

const StockOutSearch = ({
  branchCodeSelected,
  setBranchCodeSelected,
  selectedDateFrom,
  setSelectedDateFrom,
  selectedDateTo,
  setSelectedDateTo,
  onSearch,
}) => {
  const {branchList, searchBranchName, setSearchBranchName} = useBranches();

  // Validasi tanggal - pastikan dateTo tidak lebih awal dari dateFrom
  const handleDateToChange = (newDateTo) => {
    if (
      selectedDateFrom &&
      newDateTo &&
      moment(newDateTo).isBefore(moment(selectedDateFrom))
    ) {
      // Jika tanggal akhir lebih awal dari tanggal awal, set tanggal akhir sama dengan tanggal awal
      setSelectedDateTo(selectedDateFrom);
    } else {
      setSelectedDateTo(newDateTo);
    }
  };

  // Validasi tanggal - pastikan dateFrom tidak lebih akhir dari dateTo
  const handleDateFromChange = (newDateFrom) => {
    if (
      selectedDateTo &&
      newDateFrom &&
      moment(newDateFrom).isAfter(moment(selectedDateTo))
    ) {
      // Jika tanggal awal lebih akhir dari tanggal akhir, set tanggal awal sama dengan tanggal akhir
      setSelectedDateFrom(selectedDateTo);
    } else {
      setSelectedDateFrom(newDateFrom);
    }
  };

  return (
    <Box sx={{p: 3, borderBottom: "1px solid", borderColor: "divider"}}>
      <Grid
        container
        spacing={2}
        sx={{
          alignItems: "center",
        }}
      >
        <Grid item xs={12} sm={3}>
          <Stack spacing={1}>
            <Typography variant="caption" sx={{fontWeight: 600}}>
              CHOOSE OUTLET
            </Typography>
            <PickerSearch
              dataList={branchList}
              onInputChange={(event, newInputValue) => {
                setSearchBranchName(newInputValue);
              }}
              onChange={(e, v) => {
                if (v) {
                  setBranchCodeSelected(v.branchCode);
                } else {
                  setBranchCodeSelected("");
                }
              }}
              getOptionLabel={(branchList) => branchList.branchName || ""}
              labelPicker="Choose Outlet"
              placeholderPicker="search outlet"
              sizePicker="small"
              isVisibleLabelPicker={false}
            />
          </Stack>
        </Grid>

        <Grid item xs={12} sm={3}>
          <Stack spacing={1}>
            <Typography variant="caption" sx={{fontWeight: 600}}>
              DATE FROM
            </Typography>
            <FormDatePicker
              labelFormDatePicker="Date From"
              dateValue={selectedDateFrom}
              onChangeDate={handleDateFromChange}
              withMaxDate={true}
            />
          </Stack>
        </Grid>

        <Grid item xs={12} sm={3}>
          <Stack spacing={1}>
            <Typography variant="caption" sx={{fontWeight: 600}}>
              DATE TO
            </Typography>
            <FormDatePicker
              labelFormDatePicker="Date To"
              dateValue={selectedDateTo}
              onChangeDate={handleDateToChange}
              withMaxDate={true}
              minDate={selectedDateFrom} // Tambahkan min date berdasarkan selectedDateFrom
            />
          </Stack>
        </Grid>

        <Grid
          item
          xs={12}
          sm={3}
          sx={{
            display: "flex",
            alignItems: "end",
            height: "100%",
          }}
        >
          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            onClick={onSearch}
            sx={{
              width: "150px",
              mt: {xs: 1, sm: 1, md: 3, lg: 3},
            }}
          >
            Search
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StockOutSearch;
